import { GameRepository } from "../../../../data/repository/game/GameRepository";
import { Message } from "../../../model/Auth";
import { GiveRatingRequestModel } from "../../../model/Game";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GameGiveRatingUseCase {
  invoke: (
    questionId: string,
    model: GiveRatingRequestModel,
  ) => Promise<ResponseState<Message>>;
}

export class GameGiveRatingUseCaseImpl implements GameGiveRatingUseCase {
  private repo: GameRepository;

  constructor(repo: GameRepository) {
    this.repo = repo;
  }

  async invoke(
    questionId: string,
    model: GiveRatingRequestModel,
  ): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.giveRating(questionId, model);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
